import { useQuery } from '@tanstack/react-query'
import { portalApi, type PortalPermissions } from '@/api/portal'

const ALL_ON: PortalPermissions = {
  feedback: true, staffManagement: true, bookingRequests: true,
  invoices: true, editDetails: true, assignAttendees: true, bookSessions: true,
}

/**
 * What the tenant lets this client do in the portal. Everything is treated as on until the answer
 * arrives (the API enforces the real rules either way); `loaded` lets route guards wait for it.
 */
export function usePortalPermissions(): PortalPermissions & { loaded: boolean } {
  const { data } = useQuery({
    queryKey: ['portal-permissions'],
    queryFn: () => portalApi.getPermissions().then(r => r.data),
    staleTime: 5 * 60 * 1000,
  })
  return { ...(data ?? ALL_ON), loaded: !!data }
}
